/* Three-Piece — homepage interactions (no dependencies). */
(function () {
  'use strict';
  var doc = document.documentElement;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var clamp = function (v, a, b) { return Math.min(b === undefined ? 1 : b, Math.max(a || 0, v)); };
  var smooth = function (a, b, v) { var t = clamp((v - a) / (b - a)); return t * t * (3 - 2 * t); };
  var fmt$ = function (n) { return '$' + Math.round(n).toLocaleString('en-US'); };

  /* ---------------- Skip the round ---------------- */
  var skipBtn = document.querySelector('[data-tp-skip]');
  var skipped = false;
  try { skipped = sessionStorage.getItem('tp-skip') === '1'; } catch (e) {}
  if (skipped) doc.classList.add('tp-static');
  if (skipBtn) {
    if (skipped) skipBtn.textContent = 'View with animation';
    skipBtn.addEventListener('click', function () {
      if (skipped) {
        try { sessionStorage.removeItem('tp-skip'); } catch (e) {}
        window.location.reload();
        return;
      }
      try { sessionStorage.setItem('tp-skip', '1'); } catch (e) {}
      doc.classList.add('tp-static'); doc.classList.remove('tp-live');
      var c = document.querySelector('.tp-canvas'); if (c) c.remove();
      var p = document.getElementById('tp-piece'); if (p) p.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth' });
      skipped = true; skipBtn.textContent = 'View with animation';
    });
  }

  /* ---------------- The three layers: stage, panels, morning → dusk ---------------- */
  var piece = document.querySelector('[data-piece]');
  if (piece) {
    var panels = piece.querySelectorAll('[data-layer]');
    var ticks = piece.querySelectorAll('[data-tick]');
    var C = { chalk: [243, 239, 230], fair: [46, 70, 56], night: [22, 33, 27] };
    var mix = function (a, b, t) { return [0, 1, 2].map(function (i) { return Math.round(a[i] + (b[i] - a[i]) * t); }); };
    var last = '';
    var tick = function () {
      if (doc.classList.contains('tp-static')) {
        piece.style.background = ''; piece.removeAttribute('data-stage');
        panels.forEach(function (p) { p.classList.add('is-on'); });
        return;
      }
      var r = piece.getBoundingClientRect(), vh = window.innerHeight;
      var t = clamp(-r.top / Math.max(1, r.height - vh));
      var stage = t < 0.27 ? 'cover' : t < 0.58 ? 'mantle' : 'core';
      var col = mix(mix(C.chalk, C.fair, smooth(0.235, 0.285, t)), C.night, smooth(0.555, 0.6, t));
      piece.style.background = 'rgb(' + col.join(',') + ')';
      if (stage !== last) {
        last = stage; piece.setAttribute('data-stage', stage);
        panels.forEach(function (p) { p.classList.toggle('is-on', p.getAttribute('data-layer') === stage); });
        ticks.forEach(function (k) { k.classList.toggle('is-on', k.getAttribute('data-tick') === stage); });
      }
    };
    var queued = false;
    window.addEventListener('scroll', function () { if (!queued) { queued = true; requestAnimationFrame(function () { queued = false; tick(); }); } }, { passive: true });
    window.addEventListener('resize', tick);
    tick();
  }

  /* ---------------- Split-flap leaderboard ---------------- */
  var CHARSET = '0123456789#%+−→$ABCDEFGHJKLMNPRSTUVWXYZ';
  document.querySelectorAll('[data-flap]').forEach(function (el) {
    var target = Array.from(el.getAttribute('data-flap'));
    el.textContent = '';
    var tiles = target.map(function () { var s = document.createElement('span'); s.className = 'tp-tile'; s.setAttribute('aria-hidden', 'true'); s.textContent = ' '; el.appendChild(s); return s; });
    var settle = function () { tiles.forEach(function (t, i) { t.textContent = target[i]; }); };
    if (reduced || !('IntersectionObserver' in window)) { settle(); return; }
    var io = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      io.disconnect();
      tiles.forEach(function (t, i) {
        var steps = 10 + i * 5, n = 0;
        var iv = setInterval(function () {
          n++;
          t.classList.remove('is-flip'); void t.offsetWidth; t.classList.add('is-flip');
          if (n >= steps) { clearInterval(iv); t.textContent = target[i]; return; }
          t.textContent = CHARSET[Math.floor(Math.random() * CHARSET.length)];
        }, 70);
      });
    }, { threshold: 0.4 });
    io.observe(el);
  });

  /* ---------------- Core principle (70/20/10) ---------------- */
  var bag = document.querySelector('[data-bag]');
  if (bag) (function () {
    var KEYS = ['proven', 'promising', 'wild'];
    var state = { proven: 70, promising: 20, wild: 10 };
    var sliders = {}; KEYS.forEach(function (k) { sliders[k] = bag.querySelector('[data-bucket="' + k + '"]'); });
    var outs = {}; KEYS.forEach(function (k) { outs[k] = bag.querySelector('[data-out="' + k + '"]'); });
    var budgetEl = bag.querySelector('[data-budget]');
    var NS = 'http://www.w3.org/2000/svg';
    var svgEl = function (tag, attrs, parent) { var e = document.createElementNS(NS, tag); for (var a in attrs) e.setAttribute(a, attrs[a]); if (parent) parent.appendChild(e); return e; };

    /* dispersion dots (seeded so they don't jump around) */
    var dotsG = bag.querySelector('[data-dots]');
    var seed = 7; var rnd = function () { seed = (seed * 16807) % 2147483647; return (seed - 1) / 2147483646; };
    var gauss = function () { var u = rnd() || 1e-6, v = rnd(); return Math.sqrt(-2 * Math.log(u)) * Math.cos(2 * Math.PI * v); };
    var DOTS = 40, noise = [], dots = [];
    for (var i = 0; i < DOTS; i++) { noise.push([gauss(), gauss()]); dots.push(svgEl('circle', { class: 'dot', r: 3.6, cx: 0, cy: 0 }, dotsG)); }

    var split = function (total, parts) {
      var raw = parts.map(function (p) { return p / 100 * total; });
      var fl = raw.map(Math.floor), rem = total - fl.reduce(function (a, b) { return a + b; }, 0);
      raw.map(function (r, i) { return [r - fl[i], i]; }).sort(function (a, b) { return b[0] - a[0]; }).slice(0, rem).forEach(function (x) { fl[x[1]]++; });
      return fl;
    };

    var parseBudget = function () { var n = parseFloat(String(budgetEl.value).replace(/[^0-9.]/g, '')); return isFinite(n) ? n : 0; };

    var take = function (p, q, w) {
      if (Math.abs(p - 70) <= 2 && Math.abs(q - 20) <= 2 && Math.abs(w - 10) <= 2) return 'That’s my split: proven work carries the quarter, and new ideas still get a real chance.';
      if (w === 0) return 'No room for new experiments. This quarter is covered; next quarter has nothing new to learn from.';
      if (p >= 85) return 'Almost everything on proven work. Safe this quarter, with very little left to find what works next.';
      if (w >= 25) return 'A quarter or more on untested ideas. That’s a lot of budget riding on questions nobody has answered yet.';
      if (q <= 5) return 'Almost nothing for promising ideas, so there’s no step between proven and brand new.';
      if (p < 55) return 'Proven work drops to about half the budget or less, and it’s the part funding everything else.';
      return 'Close. My rule is 70/20/10.';
    };

    var land = function (b, n) {
      if (b === 'proven') return [472 + n[0] * 13, 82 + n[1] * 8];
      if (b === 'promising') return [498 + n[0] * 17, 72 + n[1] * 14];
      var along = n[0] * 55 - 38, perp = n[1] * 22; // the drive: long, wide, often short into the water
      return [470 + 0.928 * along + 0.372 * perp, 82 - 0.372 * along + 0.928 * perp];
    };

    var render = function () {
      var p = state.proven, q = state.promising, w = state.wild;
      KEYS.forEach(function (k) {
        sliders[k].value = state[k];
        sliders[k].style.setProperty('--v', state[k] + '%');
        sliders[k].setAttribute('aria-valuetext', state[k] + ' percent');
        outs[k].textContent = state[k] + '%';
      });
      var d = split(DOTS, [p, q, w]);
      dots.forEach(function (dot, i) {
        var b = i < d[0] ? 'proven' : i < d[0] + d[1] ? 'promising' : 'wild';
        var xy = land(b, noise[i]);
        var x = clamp(xy[0], 6, 554), y = clamp(xy[1], 6, 314);
        dot.setAttribute('class', 'dot dot--' + b);
        dot.style.transform = 'translate(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px)';
      });
      bag.querySelector('[data-take]').textContent = take(p, q, w);
      var B = parseBudget();
      KEYS.forEach(function (k) { var el = bag.querySelector('[data-amt="' + k + '"]'); if (el) el.textContent = B > 0 ? fmt$(B * state[k] / 100) : '—'; });
      var evBox = bag.querySelector('[data-ev]');
      if (evBox) {
        var A = (evBox.getAttribute('data-ev') || '').split(';').map(function (x) { var q = x.split(','); return { p: parseFloat(q[0]) / 100, m: parseFloat(q[1]) }; });
        var tot = 0;
        KEYS.forEach(function (k, i) {
          var a = A[i] || { p: 0, m: 0 }, ev = a.p * a.m, share = state[k] / 100;
          tot += share * ev;
          evBox.querySelector('[data-ev-p="' + k + '"]').textContent = Math.round(a.p * 100) + '%';
          evBox.querySelector('[data-ev-m="' + k + '"]').textContent = a.m.toFixed(1) + '×';
          evBox.querySelector('[data-ev-v="' + k + '"]').textContent = B > 0 ? fmt$(B * share * ev) : '$' + ev.toFixed(2) + ' per $1';
        });
        evBox.querySelector('[data-ev-total]').textContent = '$' + tot.toFixed(2);
      }
    };

    KEYS.forEach(function (k) {
      sliders[k].addEventListener('input', function () {
        var v = parseInt(sliders[k].value, 10);
        var others = KEYS.filter(function (o) { return o !== k; });
        var rest = 100 - v, sum = state[others[0]] + state[others[1]];
        var a = sum > 0 ? Math.round(rest * state[others[0]] / sum) : Math.round(rest / 2);
        state[k] = v; state[others[0]] = a; state[others[1]] = rest - a;
        render();
      });
    });
    budgetEl.addEventListener('input', render);
    budgetEl.addEventListener('blur', function () { var n = parseBudget(); if (n > 0) budgetEl.value = fmt$(n); render(); });
    bag.querySelector('[data-bag-reset]').addEventListener('click', function () { state = { proven: 70, promising: 20, wild: 10 }; render(); });
    render();
  })();

  /* ---------------- Did this work? — holdout simulator ---------------- */
  var course = document.querySelector('[data-course]');
  if (course) (function () {
    var M = []; try { M = JSON.parse(course.querySelector('[data-markets]').textContent); } catch (e) { return; }
    var NS = 'http://www.w3.org/2000/svg';
    var svgEl = function (tag, attrs, parent) { var e = document.createElementNS(NS, tag); for (var a in attrs) e.setAttribute(a, attrs[a]); if (parent) parent.appendChild(e); return e; };
    var pinsG = course.querySelector('[data-pins]');
    var chipsBox = course.querySelector('[data-chips]');
    var total = M.reduce(function (s, m) { return s + m.w; }, 0);
    var sel = new Set();
    var pins = [], chips = [];

    // Draw small markets on top so they stay clickable.
    M.map(function (m, i) { return [m, i]; }).sort(function (a, b) { return b[0].w - a[0].w; }).forEach(function (pair) {
      var m = pair[0], i = pair[1];
      var g = svgEl('g', { class: 'tp-pin', 'aria-hidden': 'true' }, pinsG);
      var fl = svgEl('g', { class: 'tp-pin__flag' }, g);
      svgEl('line', { x1: m.x, y1: m.y, x2: m.x, y2: m.y - 22 }, fl);
      svgEl('path', { d: 'M' + m.x + ' ' + (m.y - 22) + ' l12 3.5 l-12 3.5 z' }, fl);
      svgEl('circle', { cx: m.x, cy: m.y, r: (3 + Math.sqrt(m.w) * 2.4).toFixed(1) }, g);
      var lb = svgEl('text', { class: 'tp-pin__label', x: m.x + 9, y: m.y + 14 }, g); lb.textContent = m.n;
      g.addEventListener('click', function () { toggle(i); });
      pins[i] = g;
    });
    M.forEach(function (m, i) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'tp-chip'; b.textContent = m.n; b.setAttribute('aria-pressed', 'false');
      b.addEventListener('click', function () { toggle(i); });
      chipsBox.appendChild(b); chips[i] = b;
    });

    var shareEl = course.querySelector('[data-share]'), shareBar = course.querySelector('[data-share-bar]');
    var playBtn = course.querySelector('[data-play]');
    var share = function () { var s = 0; sel.forEach(function (i) { s += M[i].w; }); return s / total; };
    var sync = function () {
      M.forEach(function (m, i) { var on = sel.has(i); pins[i].classList.toggle('is-dark', on); chips[i].setAttribute('aria-pressed', on ? 'true' : 'false'); });
      var s = share();
      shareEl.textContent = sel.size ? 'Selected markets: ' + (s * 100).toFixed(1) + '% of baseline sales · ' + sel.size + ' market' + (sel.size === 1 ? '' : 's') : 'No markets selected';
      shareBar.style.width = Math.min(100, s / 0.4 * 100) + '%';
      playBtn.disabled = sel.size === 0;
    };
    var toggle = function (i) { if (sel.has(i)) sel.delete(i); else sel.add(i); sync(); };

    course.querySelector('[data-clear]').addEventListener('click', function () { sel.clear(); sync(); });
    course.querySelector('[data-caddie]').addEventListener('click', function () {
      sel.clear();
      var regions = {};
      M.forEach(function (m, i) { if (m.w < 5) (regions[m.g] = regions[m.g] || []).push(i); });
      Object.keys(regions).forEach(function (g) {
        var ids = regions[g].sort(function (a, b) { return M[a].w - M[b].w; });
        var med = M[ids[Math.floor(ids.length / 2)]].w;
        var pick = ids.reduce(function (best, i) { return Math.abs(M[i].w - med) < Math.abs(M[best].w - med) ? i : best; }, ids[0]);
        sel.add(pick);
      });
      while (share() > 0.16) { var big = -1; sel.forEach(function (i) { if (big < 0 || M[i].w > M[big].w) big = i; }); sel.delete(big); }
      sync();
    });

    /* simulation */
    var gauss = function () { var u = Math.random() || 1e-6, v = Math.random(); return Math.sqrt(-2 * Math.log(u)) * Math.cos(2 * Math.PI * v); };
    var mean = function (a) { return a.reduce(function (s, x) { return s + x; }, 0) / a.length; };
    var sd = function (a) { var m = mean(a); return Math.sqrt(a.reduce(function (s, x) { return s + (x - m) * (x - m); }, 0) / (a.length - 1)); };

    var play = function () {
      var W = 12, PRE = 6;
      var L = 0.06 + Math.random() * 0.06;
      var regionsAll = ['NE', 'SE', 'MW', 'SC', 'W', 'NW'];
      var shockRegion = regionsAll[Math.floor(Math.random() * regionsAll.length)];
      var shock = (Math.random() < 0.5 ? -1 : 1) * (0.05 + Math.random() * 0.05);
      var H = [], Cc = [];
      for (var k = 0; k < W; k++) {
        var h = 0, c = 0;
        M.forEach(function (m, i) {
          var season = 1 + 0.03 * Math.sin(k / 2) + 0.004 * k;
          var v = m.w * season * (1 + gauss() * 0.035 / Math.sqrt(m.w));
          if (k >= PRE && m.g === shockRegion) v *= 1 + shock;
          if (k >= PRE && sel.has(i)) v *= 1 - L * (1 + gauss() * 0.25);
          if (sel.has(i)) h += v; else c += v;
        });
        H.push(h); Cc.push(c);
      }
      // Weekly ratio of holdout sales to control sales, before and after ads pause.
      var ratios = H.map(function (h, k) { return h / Cc[k]; });
      var pre = ratios.slice(0, PRE), post = ratios.slice(PRE);
      var preRatio = mean(pre), postMean = mean(post);
      var e = 1 - postMean / preRatio;
      // Uncertainty comes from both periods (delta method), with a t critical value for 10 degrees of freedom.
      var rel2 = (sd(post) * sd(post)) / (post.length * postMean * postMean) + (sd(pre) * sd(pre)) / (pre.length * preRatio * preRatio);
      var se = (postMean / preRatio) * Math.sqrt(rel2), T = 2.228, ci = T * se;
      var postRatio = postMean;
      var s = share();

      // region concentration of the holdout
      var byR = {}; sel.forEach(function (i) { byR[M[i].g] = (byR[M[i].g] || 0) + M[i].w; });
      var hw = 0; Object.keys(byR).forEach(function (g) { hw += byR[g]; });
      var topShare = 0, topRegion = ''; Object.keys(byR).forEach(function (g) { if (byR[g] / hw > topShare) { topShare = byR[g] / hw; topRegion = g; } });

      var pct = function (x) { return (x >= 0 ? '+' : '−') + Math.abs(x * 100).toFixed(1) + '%'; };
      course.querySelector('[data-empty]').hidden = true;
      course.querySelector('[data-body]').hidden = false;
      course.querySelector('[data-lift]').innerHTML = pct(e) + '<small>± ' + (ci * 100).toFixed(1) + ' pts · 95% interval</small>';
      course.querySelector('[data-true]').innerHTML = pct(L) + '<small>known only because this is simulated</small>';
      course.querySelector('[data-cost]').innerHTML = (s * L * 100).toFixed(2) + '%<small>of total sales during the six test weeks</small>';

      var v;
      var off = Math.abs(e - L);
      if (s < 0.03) v = '<strong>Select more markets.</strong> This holdout is too small to separate the effect from noise.';
      else if (topShare > 0.7 && sel.size > 0 && topRegion === shockRegion && off > 0.015) v = '<strong>These markets share a region</strong>, and something unrelated to the ads changed there during the test. The estimate is off by ' + (off * 100).toFixed(1) + ' points.';
      else if (e - ci <= 0) v = '<strong>This run is inconclusive.</strong> There isn’t enough precision to separate the effect from noise.';
      else if (s > 0.25) v = 'This run suggests a positive effect: around ' + pct(e) + '. <strong>But it paused ads across ' + Math.round(s * 100) + '% of sales.</strong> Consider what the answer needs to be worth.';
      else v = '<strong>This run suggests a positive effect: around ' + pct(e) + '.</strong> The estimate still depends on how well the markets compare and how much uncertainty remains.';
      if (topShare > 0.7 && sel.size > 0 && v.indexOf('share a region') < 0 && s >= 0.03) v += ' <em>Most of these markets share a region, so a regional change could have been mistaken for an ad effect.</em>';
      course.querySelector('[data-verdict]').innerHTML = v;
      var nReg = Object.keys(byR).length;
      var steps = [
        '<b>Before.</b> In weeks 1–6, the markets you picked ran at <span class="num">' + (preRatio * 100).toFixed(2) + '%</span> of the sales of the markets that kept spending. That ratio is the baseline.',
        '<b>After.</b> With ads paused, it averaged <span class="num">' + (postRatio * 100).toFixed(2) + '%</span>. Effect = 1 − ' + (postRatio * 100).toFixed(2) + ' ÷ ' + (preRatio * 100).toFixed(2) + ' = <span class="num">' + pct(e) + '</span> of sales in those markets. Put another way, the ads lifted sales about <span class="num">' + pct(e / (1 - e)) + '</span> over a no-ads baseline.',
        '<b>How sure?</b> Six weeks before and six after, so the noise in both periods counts. Standard error <span class="num">' + (se * 100).toFixed(2) + '</span> pts; with only twelve weeks, the 95% interval is ±2.23 × SE = <span class="num">±' + (ci * 100).toFixed(1) + '</span> pts. Halve the holdout and that range grows by roughly √2: noise shrinks slowly as data grows.',
        '<b>What could fool us?</b> ' + sel.size + ' market' + (sel.size === 1 ? '' : 's') + ' across ' + nReg + ' region' + (nReg === 1 ? '' : 's') + '. ' + (topShare > 0.7 ? 'Most sit in one region, so a regional swing could pass for an ad effect.' : 'Spread across regions, so one regional swing is less likely to fake a result.')
      ];
      try { if (window.tpCard) window.tpCard.mark('holdout'); if (window.Shopify && Shopify.analytics) Shopify.analytics.publish('holdout_run', { markets: sel.size, share_pct: Math.round(s * 100), effect_pct: +(e * 100).toFixed(1) }); } catch (err) {}
      course.querySelector('[data-math]').innerHTML = steps.map(function (s) { return '<li>' + s + '</li>'; }).join('');

      // chart: indexed weekly sales, control vs holdout
      var chart = course.querySelector('[data-chart]'); chart.innerHTML = '';
      var idxH = H.map(function (x) { return x / mean(H.slice(0, PRE)) * 100; });
      var idxC = Cc.map(function (x) { return x / mean(Cc.slice(0, PRE)) * 100; });
      var all = idxH.concat(idxC), lo = Math.min.apply(null, all) - 1, hi = Math.max.apply(null, all) + 1;
      var X = function (k) { return 40 + k * (360 / (W - 1)); }, Y = function (v) { return 140 - (v - lo) / (hi - lo) * 118; };
      svgEl('rect', { x: X(PRE) - 15, y: 14, width: X(W - 1) - X(PRE) + 30, height: 132, fill: 'rgba(176,141,87,.08)' }, chart);
      [['Before the test', X(1)], ['Ads paused', X(PRE)]].forEach(function (l) { var tx = svgEl('text', { x: l[1] - 12, y: 164, fill: '#C9C5BA', 'font-size': 10, 'font-weight': 700, 'letter-spacing': '.1em' }, chart); tx.textContent = l[0].toUpperCase(); });
      svgEl('line', { x1: 30, x2: 410, y1: Y(100), y2: Y(100), stroke: 'rgba(243,239,230,.18)', 'stroke-dasharray': '3 4' }, chart);
      var path = function (arr) { return arr.map(function (v, k) { return (k ? 'L' : 'M') + X(k).toFixed(1) + ' ' + Y(v).toFixed(1); }).join(' '); };
      svgEl('path', { class: 'ln', d: path(idxC), stroke: '#F3EFE6', pathLength: 1 }, chart);
      svgEl('path', { class: 'ln', d: path(idxH), stroke: '#D9BC86', pathLength: 1, style: 'animation-delay:.25s' }, chart);
      var l1 = svgEl('text', { x: 408, y: Y(idxC[W - 1]) - 6, fill: '#F3EFE6', 'font-size': 10.5, 'text-anchor': 'end', 'font-weight': 700 }, chart); l1.textContent = 'Ads continue';
      var l2 = svgEl('text', { x: 408, y: Y(idxH[W - 1]) + 14, fill: '#D9BC86', 'font-size': 10.5, 'text-anchor': 'end', 'font-weight': 700 }, chart); l2.textContent = 'Ads paused';
    };
    /* A nearest-neighbour route through every market that keeps spending, drawn before the readout. */
    var routeG = course.querySelector('[data-route]'), travG = course.querySelector('[data-traveler]');
    var driving = false;
    var drive = function () {
      if (driving) return;
      var stops = M.map(function (m, i) { return i; }).filter(function (i) { return !sel.has(i); });
      if (!stops.length) { play(); return; }
      var start = stops.reduce(function (a, i) { return M[i].x < M[a].x ? i : a; }, stops[0]);
      var order = [start], left = new Set(stops); left.delete(start);
      while (left.size) {
        var cur = M[order[order.length - 1]], best = -1, bd = Infinity;
        left.forEach(function (i) { var d = Math.hypot(M[i].x - cur.x, M[i].y - cur.y); if (d < bd) { bd = d; best = i; } });
        order.push(best); left.delete(best);
      }
      var d = order.map(function (i, k) { return (k ? 'L' : 'M') + M[i].x + ' ' + M[i].y; }).join(' ');
      routeG.innerHTML = ''; travG.innerHTML = '';
      svgEl('path', { class: 'tp-route-under', d: d }, routeG);
      var line = svgEl('path', { class: 'tp-route-line', d: d }, routeG);
      var len = line.getTotalLength();
      var car = svgEl('circle', { class: 'tp-traveler', r: 6, cx: M[start].x, cy: M[start].y }, travG);
      if (reduced) { play(); return; }
      driving = true; playBtn.disabled = true;
      line.style.strokeDasharray = '7 6'; 
      var mask = svgEl('path', { d: d, fill: 'none', stroke: '#16211B', 'stroke-width': 8, 'stroke-linecap': 'round', 'stroke-linejoin': 'round' }, routeG);
      var t0 = performance.now(), dur = 2200;
      var step = function (now) {
        var k = Math.min(1, (now - t0) / dur), e = k < .5 ? 2 * k * k : 1 - Math.pow(-2 * k + 2, 2) / 2;
        mask.style.strokeDasharray = len + ' ' + len; mask.style.strokeDashoffset = -e * len;
        var pt = line.getPointAtLength(e * len); car.setAttribute('cx', pt.x); car.setAttribute('cy', pt.y);
        if (k < 1) requestAnimationFrame(step);
        else { mask.remove(); driving = false; playBtn.disabled = sel.size === 0; play(); }
      };
      requestAnimationFrame(step);
    };
    playBtn.addEventListener('click', drive);
    sync();
  })();
})();
